import { styled, css } from 'styled-components';

import { HeaderContainerProps } from './types';

export const SectionsContainers = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-inline: auto;
  padding-block: var(--spacing-10);
  padding-bottom: 0;
  gap: var(--spacing-10);

  @media screen and (min-width: 1024px) {
    gap: 80px;
  }
`;

export const HeaderContainer = styled.div<HeaderContainerProps>`
  ${({ $isSticky, $hasPaddingTop }) =>
    $isSticky &&
    css`
      z-index: 2;
      position: sticky;
      top: ${$hasPaddingTop ? '43px' : '0px'};
    `};

  display: flex;
  justify-content: center;

  height: 67px;

  background-color: var(--color-white);
  border-top: 1px solid #dedddb;
  border-bottom: 1px solid #dedddb;

  @media screen and (min-width: 768px) {
    ${({ $isSticky, $hasPaddingTop }) =>
      $isSticky &&
      css`
        top: ${$hasPaddingTop ? '60px' : '0px'};
      `}
    height: 70px;
  }
`;

export const HeaderContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 15px;
  align-items: center;
  height: 100%;
`;

export const ScrollNavigationItemWrapper = styled.div`
  scroll-margin-top: calc(55px + 44px + 20px);

  @media screen and (min-width: 768px) {
    /* 
    55px for Section Header 
    70px for main navigation
    40px for spacing between heading and Section Header
  */
    scroll-margin-top: calc(55px + 70px + 40px);
  }
`;
